import React from "react";

export default function JubenshaItemCard({ item, onInspect, showDescription = true, compact = false }) {
  if (!item) return null;

  const normalized = typeof item === "string" ? { title: item } : item || {};
  const title = normalized.title || normalized.name || normalized.id || "Item";
  const description = normalized.subtitle || normalized.description || normalized.note || "";
  const iconUrl = normalized.iconUrl || "https://placehold.co/64x64?text=ITEM";
  const slotLabel = normalized.slotLabel;
  const isEmpty = normalized.id === "empty";

  return (
    <button
      type="button"
      className={`inventory-item item-card ${compact ? "item-card-compact" : ""} ${isEmpty ? "item-card-empty" : ""}`}
      onClick={() => !isEmpty && onInspect?.(normalized)}
      disabled={isEmpty}
    >
      <div className="item-card-left">
        <img src={iconUrl} alt={title} className="item-icon" />
        <div className="item-text">
          <div className="item-title">{title}</div>
          {showDescription && description && <div className="item-subtitle">{description.length > 56 ? `${description.slice(0, 56)}...` : description}</div>}
          {slotLabel && <div className="item-slot-chip">{slotLabel}</div>}
        </div>
      </div>
    </button>
  );
}
